<script lang="ts">
	import type { FilterIntervalType } from 'customTypes/filterTypes';
	import FilterButton from 'components/FilterButton/FilterButton.svelte';
	import WatchlistOptionsMenu from 'components/WatchlistOptionsMenu/WatchlistOptionsMenu.svelte';
	import PlusIcon from 'assets/svg/plus.svg?component';
	import TableOptionsFilterSelect from 'components/TableOptionsFilterSelect/TableOptionsFilterSelect.svelte';
	import WatchlistModal from 'components/WatchlistModal/WatchlistModal.svelte';
	import { _ } from 'utils/i18/i18n';
	import userStore from 'stores/user';

	const period = [
		{ value: '1d', name: '1d' },
		{ value: '7d', name: '1w' },
		{ value: '30d', name: '1m' },
		{ value: '365d', name: '1y' },
		{ value: 'ytd', name: 'ytd' },
	];

	export let dark = false;
	export let filterInterval: FilterIntervalType;
	export let isEditModeEnabled;
	export let toggleWatchlist: (list: string) => void;
	export let listName = '';
	export let list = [];
	export let watchlists;

	let addToWatchlistModalIsOpened = false;

	function handleIntervalBtnClick(e: MouseEvent & { target: HTMLElement }) {
		filterInterval = e.target.id as FilterIntervalType;
	}
	function handleIntervalSelectClick(selectedValue: FilterIntervalType) {
		filterInterval = selectedValue;
	}
	function handleAddBtnClick() {
		addToWatchlistModalIsOpened = !addToWatchlistModalIsOpened;
	}
</script>

<div class="wrapper container" class:dark>
	<div class="functionality">
		<button type="button" class="add-btn" on:click={handleAddBtnClick}>
			<PlusIcon width={12} height={12} class="add-btn-icon" />
			{$_('watchlist.addCoins')}
		</button>
		<WatchlistOptionsMenu
			{dark}
			{listName}
			{list}
			bind:isEditModeEnabled
			{toggleWatchlist}
			{watchlists}
		/>
	</div>
	<div class="intervals-wrapper">
		{#each period as val}
			<FilterButton
				class="period-btn"
				{dark}
				isActive={filterInterval === val.value}
				title={val.name}
				id={val.value}
				on:click={handleIntervalBtnClick}
			/>
		{/each}
	</div>
	<div class="select-mobile">
		<TableOptionsFilterSelect
			variants={period}
			handleClick={handleIntervalSelectClick}
			{dark}
			minWidth={89}
			selectedScale={period.find((item) => item.value === filterInterval)}
		/>
	</div>
	{#key listName}
		<WatchlistModal
			{dark}
			uid={$userStore._id}
			bind:active={addToWatchlistModalIsOpened}
			toggleModal={handleAddBtnClick}
			{list}
			{listName}
		/>
	{/key}
</div>

<style lang="scss">
	@import 'watchlistFilterTab';
</style>
